import { AloftDate, AloftPrice, AloftPriceJSON } from '@aloft/shared-objects';
import {
  AnalysisPeriod,
  CustomMonthlyPriceTrend,
  makeCustomMonthlyPriceTrends,
} from '@aloft/toolkit-shared';
import { IsoMonth } from '@aloft/toolkit-shared/lib/syntax/fnma/types';

import { useRef } from 'react';

type MergeTrendsParams = {
  analysisPeriod: AnalysisPeriod;
  effectiveDate: AloftDate;
  previousTrends: CustomMonthlyPriceTrend[];
};

export function useMergeCustomMonthPriceTrends() {
  const prevTrendValueMap: React.MutableRefObject<Record<IsoMonth, AloftPriceJSON>> = useRef({});

  /** Merges previous Custom Monthly Price trends with trends for new analysis period. */
  const mergeTrends = ({ analysisPeriod, effectiveDate, previousTrends }: MergeTrendsParams) => {
    for (const { month, value } of previousTrends) {
      prevTrendValueMap.current[month] = value;
    }

    const mergedTrends = makeCustomMonthlyPriceTrends({
      analysisPeriod,
      effectiveDate,
      initialValue: (month) => {
        return prevTrendValueMap.current[month] ?? AloftPrice.zero.toJSON();
      },
    });

    return mergedTrends;
  };

  return { mergeTrends };
}
